// import axios from "axios"
import axios from "../../../constants/axios"

import { navigate } from "gatsby"

import endpoints from "../../../constants/endpoints"
import serializeForm from "../../../utils/serialize-form-data"

export const COMPANY_DETAIL_FETCH = async (
  dispatch,
  setCompanyDetailFormData,
  companyDetailFormData,
) => {
  try {
    const response = await axios.get(
      process.env.GATSBY_BASE_URL + endpoints.COMPANY_PROFILE_FETCH
    )
    const { data } = response

    if (data && data.profile && data.contact) {
      setCompanyDetailFormData({
        ...companyDetailFormData,
        organization_name: data.profile.organization_name || "",
        year_of_establishment: data.profile.year_of_establishment,
        no_of_employees: data.profile.num_of_employees || "",
        industry: data.profile.industry || "",
        country: data.profile.country || "",
        city: data.contact.city || "",
        address: data.contact.address || "",
        email: data.contact.email || "",
        website: data.contact.website || "",
        phonenumber: data.contact.phonenumber || "",
        landline: data.contact.landline || "",
        about: data.profile.about || "",
        avatar: data.profile.avatar || "",
        id: data.profile.id,
        state: data.contact.province_id,
      })
      dispatch({
        type: "PROFILE_VERIFIED",
        payload: { verified: data.profile.verified, data: data.profile },
      })
      dispatch({
        type: "COMPANY_DATA",
        payload: data,
      })
    }

    return response
  } catch (err) {
    if (err?.response?.status === 403) {
      dispatch({ type: "LOGOUT" })
    }
    return err?.response
  }
}

export const COMPANY_COUNTRY_FETCH = async (
  companyDetailFormData,
  setState,
  setCity
) => {
  try {
    if (companyDetailFormData.country) {
      const res = await axios.get(
        process.env.GATSBY_BASE_URL +
        endpoints.CONFIG_COUNTRY_FETCH +
        companyDetailFormData.country +
        "/"
      )
      if (res.data) {
        if (res.data.province) {
          setState(res.data.province)
          if (companyDetailFormData.state) {
            const dist = res.data.province.find(
              prov =>
                prov.id.toString() === companyDetailFormData.state.toString()
            )
            if (dist.districts) {
              setCity(dist.districts)
            }
          }
        }
      }
    }
  } catch (error) { }
}

export const PROFILE_IMAGE_UPLOAD = async (
  image_file,
  setProcessing,
  setErrors
) => {
  try {
    if (!!image_file) {
      let formData = new FormData()
      formData.append("avatar", image_file, image_file.name)
      const res = await axios.post(
        process.env.GATSBY_BASE_URL + endpoints.COMPANY_AVATAR_SUBMIT,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      if (res && res.status !== 200) {
        setErrors({ errors: { message: "Something went wrong" } })
      }
    }
    setProcessing(false)
  } catch (err) {
    if (err.response && err.response.data && err.response.data.message) {
      setErrors({ errors: err.response.data.message })
    } else {
      setErrors({ errors: { message: "Something went wrong" } })
    }
    setProcessing(false)
  }
}

export const COMPANY_DETAIL_FORM_SUBMIT = async (
  companyDetailFormData,
  setError,
  setIsProcessing,
  isContinue,
  state,
  dispatch
) => {
  const data = new FormData()
  data.append("email", companyDetailFormData?.email)
  data.append("phonenumber", companyDetailFormData?.phonenumber)
  data.append("landline", companyDetailFormData?.landline)
  if (companyDetailFormData?.image_file !== undefined) {
    data.append(
      "avatar",
      companyDetailFormData?.image_file,
      companyDetailFormData?.image_file.name
    )
  }
  data.append("website", companyDetailFormData?.website)
  data.append("address", companyDetailFormData?.address)
  data.append("city", companyDetailFormData?.city)
  data.append("industry", companyDetailFormData?.industry)
  data.append("organization_name", companyDetailFormData?.organization_name)
  data.append("about", companyDetailFormData?.about)
  data.append("num_of_employees", companyDetailFormData?.no_of_employees)
  data.append(
    "year_of_establishment",
    companyDetailFormData?.year_of_establishment
  )
  data.append("country", companyDetailFormData?.country)
  data.append("province_id", companyDetailFormData?.province)
  try {
    const res = await axios.patch(
      process.env.GATSBY_BASE_URL + endpoints.COMPANY_PROFILE_UPDATE,
      data,
      { headers: { "Content-Type": "multipart/form-data" } }
    )
    if (!companyDetailFormData?.image_file && !companyDetailFormData?.avatar) {
      setError({ avatar: "Avatar is required" })
    }
    const profileData = serializeForm(data)
    if (res.status === 200 && !!dispatch) {
      const data = {
        ...profileData,
        avatar: companyDetailFormData?.avatar_name,
      }
      setError({ message: "Profile updated successfully" })
      dispatch({
        type: "PROFILE_VERIFIED",
        payload: {
          verified: state?.hasProfile,
          data,
        },
      })
    }

    setIsProcessing(false)
    return res
  } catch (err) {
    if (err && err?.response && err?.response?.data) {
      setError(err?.response?.data)
    }
    if (
      !companyDetailFormData?.image_file &&
      !companyDetailFormData?.avatar &&
      err?.reponse &&
      err?.response.data
    ) {
      setError({ ...err?.response?.data?.errors, avatar: "Avatar is required" })
    }
    setIsProcessing(false)
    return err?.response
  }

  // const fd_contact = new FormData()
  // fd_contact.append("phonenumber", companyDetailFormData.phone)
  // fd_contact.append("address", companyDetailFormData.address)
  // fd_contact.append("landline", companyDetailFormData.landline)
  // fd_contact.append("email", companyDetailFormData.email)
  // fd_contact.append("website", companyDetailFormData.website)
  // try {
  //   await axios.put(
  //     `${process.env.GATSBY_BASE_URL}/api/company/contact/update/${companyDetailFormData.id}/`,
  //     fd_contact,
  //     {
  //       headers: {
  //         authorization: `Token ${token}`,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     }
  //   )
  //   setIsProcessing(false)
  //   navigate("/company/social")
  // } catch (err) {
  //   setIsProcessing(false)
  //   const err_data = err.response.data
  //   setError({ ...error, ...err_data })
  // }
}

export const COMPANY_DETAIL_PROFILE_FETCH = async (
  id,
  setProfile,
  setWholePageLoading
) => {
  try {
    const response = await axios.get(
      process.env.GATSBY_BASE_URL + endpoints.COMPANY_PROFILE_ROUTE + id + "/"
    )
    const { data } = response
    setProfile(data)

    setWholePageLoading(false)
  } catch (err) {
    const code = err?.response?.status
    if (code === 500 || code === 400 || code === 404) {
      navigate("/404")
    } else {
      setWholePageLoading(false)
    }
  }
}
